import { useCallback } from "react"

import { Tabs, TabsList, TabsTrigger } from "@/domains/common/components/tabs"

import { LiquidityType } from "../types"

export interface LiquidityTypeTabsProps {
  value: LiquidityType
  onValueChange: (value: LiquidityType) => void
  className?: string
}

const isValidValue = (v: string): v is LiquidityType => {
  return ["all", "stable", "volatile"].includes(v)
}

export const LiquidityTypeTabs = ({ value, onValueChange, className }: LiquidityTypeTabsProps) => {
  const handleValueChange = useCallback(
    (value: string) => {
      if (!isValidValue(value)) {
        console.warn(`Invalid tab value: ${value}`)
        return "all"
      }
      onValueChange(value as LiquidityType)
    },
    [onValueChange],
  )

  return (
    <Tabs value={value} defaultValue="all" onValueChange={handleValueChange}>
      <TabsList className={className}>
        <TabsTrigger value="all">All</TabsTrigger>
        <TabsTrigger value="volatile">Volatile</TabsTrigger>
        <TabsTrigger value="stable">Stable</TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
